import { formatToolbarBureauList, TOOLBAR_FLOW_SHORT_TITLE, type ToolbarRequestType } from './creditBlockToolbarFlowUtils';

type BureauKey = 'equifax' | 'experian' | 'transunion' | 'chexsystems';

export function toolbarFlowStartedMessage(requestType: ToolbarRequestType, bureaus: BureauKey[]): string {
  const flowTitle = TOOLBAR_FLOW_SHORT_TITLE[requestType];
  const bureauList = formatToolbarBureauList(bureaus);
  const n = bureaus.length;
  return `${flowTitle}: creating ${n} case${n === 1 ? '' : 's'} (${bureauList}). Filing Credit Block history per bureau…`;
}

export function toolbarFlowSuccessMessage(requestType: ToolbarRequestType, createdCount: number, bureaus: BureauKey[]): string {
  const flowTitle = TOOLBAR_FLOW_SHORT_TITLE[requestType];
  const bureauList = formatToolbarBureauList(bureaus);
  return `${flowTitle}: done — ${createdCount} case${createdCount === 1 ? '' : 's'} and matching Credit Block history for ${bureauList}.`;
}

export function toolbarFlowPartialMessage(
  requestType: ToolbarRequestType,
  createdCount: number,
  requestedCount: number,
  bureaus: BureauKey[],
  failedBureaus: string[]
): string {
  const flowTitle = TOOLBAR_FLOW_SHORT_TITLE[requestType];
  const bureauList = formatToolbarBureauList(bureaus);
  return `${flowTitle}: partial — ${createdCount} of ${requestedCount} succeeded (${bureauList}). Failed bureaus: ${failedBureaus.join(', ')}.`;
}

export function toolbarFlowNoneCreatedMessage(requestType: ToolbarRequestType, bureaus: BureauKey[]): string {
  const flowTitle = TOOLBAR_FLOW_SHORT_TITLE[requestType];
  const bureauList = formatToolbarBureauList(bureaus);
  return `${flowTitle}: no cases were created for ${bureauList}. Check Gobodo and retry, or confirm bureau Credit_Bureaus__c rows exist.`;
}
